import { swoopAPI } from '@/api'

export const getDocumentsList = companyId => swoopAPI.get(`/api/v1/document/${companyId}/list`)
export const sendDocument = async (data, { companyId, type, title }, config) =>
  await swoopAPI.post(`/api/v1/document/company/${companyId}/type/${type}`, data, { ...config, params: { title } })
export const editTypeDocument = (documentId, type) => swoopAPI.put(`/api/v1/document/${documentId}/type/${type}`)
export const downloadDocument = documentId => swoopAPI.get(`/api/v1/document/${documentId}/download`, { responseType: 'blob' })
export const deleteDocument = async documentId => await swoopAPI.delete(`/api/v1/document/${documentId}`)

export const setJourneyDocumentsStatus = params => swoopAPI.post('/api/v1/documents/state', null, { params })
